export interface ParsedAirlineDepartureTime {
  hours: number;
  minutes: number;
}

/**
 * Parses an airline-provided departure time in `HH:MM` format.
 * Returns `null` for any invalid input (non-string, non-numeric, out of range, malformed).
 */
export const parseAirlineDepartureTime = (time: unknown): ParsedAirlineDepartureTime | null => {
  if (typeof time !== "string") {
    return null;
  }

  const [hoursString, minutesString] = time.split(":");
  const hours = Number(hoursString);
  const minutes = Number(minutesString);

  const isTimeValid =
    Number.isInteger(hours) && Number.isInteger(minutes) && hours >= 0 && hours <= 23 && minutes >= 0 && minutes <= 59;

  if (!isTimeValid) {
    return null;
  }

  return { hours, minutes };
};
